(function() {
    const script = document.currentScript;
    const API_URL = script.getAttribute('data-api-url');
    const API_KEY = script.getAttribute('data-api-key');
  
    // Fetch API wrappers
    const request = new (class RequestHelper {
      async fetchRaw(url, properties) {
        const response = await fetch(url, properties);
  
        // Automatically parses response data
        let data = await response.text();
        try {
          data = JSON.parse(data);
        } catch(ex) { }
  
        // Handles errors
        if (!response.ok) {
          throw data;
        }
  
        return data;
      }
  
      async fetch(endpoint, properties) {
        return await this.fetchRaw(`${API_URL}${endpoint}`, {
          ...properties,
          headers: {
            ...(properties?.headers || {}),
            'Accept': 'application/json',
            'Authorization': `Bearer ${API_KEY}`,
          }
        })
      }
  
      async get(endpoint) {
        return await this.fetch(endpoint);
      }
  
      async post(endpoint, data) {
        return await this.fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data || {}),
        });
      }
    });
  
    // Registers global API
    const API = window.IntegrationAPI = {};
  
    // Quotes API
    API.quotes = new (class QuotesAPI {
      async getCustomerQuotes() {
        return await request.get('/quotes');
      }
      async createQuote(lineItems, options) {
        if ((lineItems || []).length == 0) {
          throw 'You need to include at least one line item on your quote!';
        }
  
        return await request.post('/quotes/create', {
          ...options,
          items: lineItems,
        });
      }
      async createQuoteFromCurrentCart(options) {
        // Fetches cart data
        const cart = await request.fetchRaw('/cart.js');
  
        // Creates the quote
        const response = await this.createQuote(cart.items.map(
          item => Object.assign({
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties,
          })
        ), Object.assign({
            note: cart.note,
          }, options || {})
        );
  
        // Clears cart
        await request.fetchRaw('/cart/clear.js');
  
        return response;
      }
    });
  })();